import PlaceImage from '../components/PlaceImage';
import Icon from '../components/Icon';
import React from 'react';
import './Fleet.css';

const WA = '919445879508';

const vehicles = [
  {
    name: '4-Seater Car',
    seats: 4, type: 'Tata Zest',
    img:'/images/destinations/tata-zest.jpg',
    features: ['Air Conditioned', 'Music System', 'Comfortable Seats', 'Large Boot Space', 'Phone Charging'],
    best: ['Couples', 'Honeymoon Trips', 'Small Families', 'Solo Travellers'],
    desc: 'Our 4-seater cars are ideal for couples and small families. Compact yet comfortable, they handle the winding mountain roads to Kodaikanal with ease.',
    color: '#e8f5ee',
  },
  {
    name: '7-Seater SUV',
    seats: 7, type: 'Toyota Innova',
    img:'/images/destinations/toyota-innova.jpg',
    features: ['Air Conditioned', 'Spacious Cabin', 'Powerful Engine', 'Extra Luggage Space', 'Pushback Seats'],
    best: ['Families', 'Extended Family', 'Small Groups', '2–3 Couples'],
    desc: 'Our most popular choice for families and small groups. The Toyota Innova handles mountain roads excellently while keeping everyone comfortable.',
    color: '#fff8e8',
  },
  {
    name: '12-Seater Van',
    seats: 12, type: 'Tata Winger',
    img:'/images/destinations/tata-winger.jpg',
    features: ['Air Conditioned', 'Row Seating', 'Large Windows', 'Central Aisle', 'Luggage Rack'],
    best: ['Large Families', 'Friend Groups', 'Small College Trips', 'Office Groups'],
    desc: 'Perfect for larger groups who want to stay together without splitting into multiple vehicles. Comfortable, spacious, and great for mountain terrain.',
    color: '#f0f4ff',
  },
  {
    name: '25-Seater Coach Van',
    seats: 25, type: 'SML Coach Van',
    img:'/images/destinations/sml-coach-van.jpg',
    features: ['Air Conditioned', 'Push-back Seats', 'PA System', 'Large Windows', 'Luggage Compartment'],
    best: ['College Groups', 'Corporate Outings', 'Tour Groups', 'Large Events'],
    desc: 'Our largest vehicle for big group travel. Ideal for college excursions, corporate team outings, and large tour groups exploring Kodaikanal together.',
    color: '#fef0f0',
  },
];

export default function Fleet() {
  return (
    <div className="fleet-page page-enter">
      <div className="inner-hero" style={{ backgroundImage: "url('/images/destinations/kodaikanal.jpg')" }}>
        <div className="inner-hero__overlay" />
        <div className="container inner-hero__content">
          <p className="eyebrow">Travel in Comfort</p>
          <h1 className="display-title light">Our Fleet</h1>
          <div className="amber-line" />
          <p>4 vehicle types — for couples, families, and large groups. All AC, well-maintained.</p>
        </div>
      </div>

      <section className="section-pad container">
        <p className="fleet-photo-note">Model reference photos. Vehicle appearance and configuration may vary.</p>
        <div className="fleet-detail-grid">
          {vehicles.map((v, i) => (
            <div key={v.name} className={`vehicle-detail card ${i % 2 === 1 ? 'reverse' : ''}`}>
              <div className="vehicle-detail__img">
                <PlaceImage src={v.img} alt={v.type} loading="lazy" />
                <div className="vehicle-detail__badge">
                  <span className="vehicle-detail__seats"> {v.seats} Seats</span>
                </div>
              </div>
              <div className="vehicle-detail__info" style={{ background: v.color }}>
                <p className="eyebrow">Available Now</p>
                <h2 className="vehicle-detail__name">{v.name}</h2>
                <p className="vehicle-detail__type">{v.type}</p>
                <div className="amber-line" />
                <p className="vehicle-detail__desc">{v.desc}</p>
                <div className="vehicle-detail__cols">
                  <div>
                    <p className="vehicle-detail__label">Features</p>
                    <ul>
                      {v.features.map(f => <li key={f}><span>✓</span> {f}</li>)}
                    </ul>
                  </div>
                  <div>
                    <p className="vehicle-detail__label">Best For</p>
                    <ul>
                      {v.best.map(b => <li key={b}><span><Icon name="mountain" /></span> {b}</li>)}
                    </ul>
                  </div>
                </div>
                <div className="vehicle-detail__actions">
                  <a href={`https://wa.me/${WA}?text=Hi!%20I'd%20like%20to%20book%20the%20${encodeURIComponent(v.type + " (" + v.seats + " seats)")}%20for%20Kodaikanal`}
                     target="_blank" rel="noreferrer" className="btn-primary">
                     Book on WhatsApp
                  </a>
                  <a href="tel:+919445879508" className="btn-green"> Call Now</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
